import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { LockIcon, UserIcon, ShieldCheckIcon, AlertCircleIcon } from 'lucide-react';
export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {
    login,
    failedAttempts
  } = useAuth();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await login(email, password);
      // After successful login, redirect to 2FA setup
      //window.location.href = '/auth/setup-2fa'
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-3457">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-3458">
        <div className="flex justify-center" data-id="element-3459">
          <div className="h-12 w-12 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-3460">
            <ShieldCheckIcon className="h-8 w-8 text-white" data-id="element-3461" />
          </div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-3462">
          Sign in to your account
        </h2>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-3463">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-3464">
          <form className="space-y-6" onSubmit={handleSubmit} data-id="element-3465">
            <div data-id="element-3466">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-3467">
                Email address
              </label>
              <div className="mt-1 relative" data-id="element-3468">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-3469">
                  <UserIcon className="h-5 w-5 text-gray-400" data-id="element-3470" />
                </div>
                <input id="email" name="email" type="email" autoComplete="email" required className="appearance-none block w-full pl-10 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" value={email} onChange={e => setEmail(e.target.value)} data-id="element-3471" />
              </div>
            </div>
            <div data-id="element-3472">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-3473">
                Password
              </label>
              <div className="mt-1 relative" data-id="element-3474">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-3475">
                  <LockIcon className="h-5 w-5 text-gray-400" data-id="element-3476" />
                </div>
                <input id="password" name="password" type="password" autoComplete="current-password" required className="appearance-none block w-full pl-10 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" value={password} onChange={e => setPassword(e.target.value)} data-id="element-3477" />
              </div>
            </div>
            {error && <div className="rounded-md bg-red-50 p-4" data-id="element-3478">
                <div className="flex" data-id="element-3479">
                  <div className="flex-shrink-0" data-id="element-3480">
                    <AlertCircleIcon className="h-5 w-5 text-red-400" data-id="element-3481" />
                  </div>
                  <div className="ml-3" data-id="element-3482">
                    <p className="text-sm font-medium text-red-800" data-id="element-3483">{error}</p>
                  </div>
                </div>
              </div>}
            {failedAttempts > 0 && <div className="text-sm text-yellow-600" data-id="element-3484">
                Failed attempts: {failedAttempts}/5
              </div>}
            <div data-id="element-3485">
              <button type="submit" disabled={isLoading} className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`} data-id="element-3486">
                {isLoading ? 'Signing in...' : 'Sign in'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>;
};